// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1_AdG","validationTips":"StatementDescriptor_validationTips__2F0NH"};